module.exports = __webpack_public_path__ + "img/confirmation_popup_after_payment.e80ac1bd.png";